import styled from '@emotion/styled';
import { formatDateShort } from '@landsbankinn/l16n';
import { Prismic } from '@landsbankinn/prismic';
import { AccordionList, AccordionItem } from '@landsbankinn/ui';
import React, { useEffect } from 'react';

const Host = styled.div`
  & > section > div {
    margin: 0;
    padding: 0;
  }
`;

interface INews {
  content: string;
  date: Date;
  exchange: string;
  exchange_id: number;
  instrument_name: string;
  issuer_name: string;
  language: string;
  title: string;
  url: string;
}

const Div = styled.div`
  padding-left: 20px;
`;

interface IProps {
  count: number;
}

export function KauphollNews({ count }: IProps) {
  const [items, setItems] = React.useState<INews[] | undefined>([]);
  useEffect(() => {
    fetch(`/api/kaupholl?count=${count}`)
      .then((response) => response.json())
      .then((data) => setItems(data));
  }, []);
  if (!items?.length) {
    return null;
  }
  return (
    <Host>
      <AccordionList firstOpen={false} singleDisplay={false}>
        {items.map(RenderFaqItem)}
      </AccordionList>
    </Host>
  );
}

const RenderFaqItem = (
  { content, title, exchange_id, date }: INews,
  i: number,
) => {
  return (
    <AccordionItem
      key={`${i}-${exchange_id}`}
      title={`${Prismic.text(title)?.replace('Landsbankinn hf.: ', '')}`}
      content={
        <>
          <Div>{formatDateShort('is', new Date(date))} </Div>
          <br />
          <Div>{Prismic.text(content)}</Div>
        </>
      }
    />
  );
};
